// Client-side playback progress (Continue Watching) stored in localStorage.
const KEY = "dakid_progress";
const DONE = 0.95; // treat >=95% watched as finished

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
};
const write = (obj) => localStorage.setItem(KEY, JSON.stringify(obj));

export const saveProgress = (episode, series, currentTime, duration) => {
  if (!episode || !duration || duration < 1) return;
  const percent = currentTime / duration;
  const all = read();
  if (percent >= DONE) {
    delete all[episode.id];
    write(all);
    return;
  }
  all[episode.id] = {
    episodeId: episode.id,
    seriesId: episode.series_id,
    seriesTitle: series?.title || episode.series_title || "",
    episodeTitle: episode.title,
    season: episode.season_number,
    episode: episode.episode_number,
    thumbnail: episode.thumbnail_url || series?.banner_url || "",
    currentTime,
    duration,
    percent,
    updatedAt: Date.now(),
  };
  write(all);
};

export const getProgress = (episodeId) => read()[episodeId] || null;

export const removeProgress = (episodeId) => {
  const all = read();
  delete all[episodeId];
  write(all);
};

export const getContinueList = () =>
  Object.values(read())
    .filter((p) => p.percent > 0.02 && p.percent < DONE)
    .sort((a, b) => b.updatedAt - a.updatedAt);
